export default __webpack_public_path__ + "media/zurb/img/legacy/plunk/about-1-upload-bdb4edce3652dc0a4279e7571fac0da1.jpg";